import React from 'react';
import { connect } from 'react-redux';

import { SearchContext } from './search-context';
import { trackSort } from '../search-filter-actions';
import SortDropdown from './sort-dropdown';

export default class SearchSort extends React.Component {
    static defaultProps = {
        options: [],
        label: 'Sort by',
        className: ''
    };

    constructor(props){
        super(props);
    }

    selectOption = (e, setSort) => {
        const { options, offlineSort, onSort } = this.props;
        const { field, order } = options[e.target.value];

        setSort({ field, order }, offlineSort);
        if(onSort){
            onSort(field, order);
        }
    }

    customSelectOption = (setSort) => (sortVal) => {
        const { options, offlineSort, onSort } = this.props;
        const { field, order } = sortVal;
        setSort({ field, order }, offlineSort);
        if(onSort){
            onSort(field, order);
        }
    }

    render() {
        const { label, options, className, SortComponent } = this.props;
        let containerClass = "search-sort " + className;

        return (
            <SearchContext.Consumer>
                {({ setSort, sort }) => {
                    let value = sort && options && options.findIndex( option => option.field === sort.field && option.order === sort.order);
                    
                    if(this.props.children){
                        return ( <SortDropdown className={containerClass}>
                                    {this.props.children({label, options, setSort: this.customSelectOption(setSort), value })}
                                </SortDropdown>)
                    }else if(SortComponent){
                        return (
                            <div className={containerClass}>
                                {options.map((sortType, i) => {
                                    return (
                                        <SortComponent 
                                            sort={sortType} 
                                            key={i} 
                                            index={i}
                                            isSelected={value===i}
                                         />
                                    )
                                })}
                            </div>
                        )
                    } 
                    return (
                        <SortDropdown 
                            className={containerClass} 
                            label={label}
                            options={options}
                            value={value}
                            onChange={e => this.selectOption(e, setSort)}
                        />
                    );
                }}
            </SearchContext.Consumer>
        );
    }
}


const mapDispatchToProps = (dispatch) => {
	return {
		trackSort :(sortValue) => dispatch(trackSort(sortValue))
	}
};


//temp wrapper to dispatch sort event
const TackSortWrapper = ({children, trackSort, ...rest}) => {
	return children({ trackSort, ...rest});
}

export const TrackSort = connect(null, mapDispatchToProps)(TackSortWrapper);